import { __assign, __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { media } from '@elseu/sdu-titan';
import { forwardRef } from 'react';
import { css } from 'styled-components';
import { createSlug } from '../../utilities/createSlug/createSlug.js';

/**
 * Get the correct padding values
 * @param {GetPaddingValueProps} { padding, theme }
 * @returns {string} Padding value
 */
var getPaddingValues = function (_a) {
  var padding = _a.padding,
    theme = _a.theme;
  return Array.isArray(padding) ? padding.map(function (value) {
    return theme.spacing[value];
  }) : new Array(4).fill(theme.spacing[padding]);
};
/**
 * Get section spacing for different media breakpoints
 * @param {GetSectionSpacingProps} { theme, maxWidth, xPadding, yPadding }
 * @returns {string} CSS styles for section spacing
 */
var getSectionSpacing = function (_a) {
  var theme = _a.theme,
    maxWidth = _a.maxWidth,
    xPadding = _a.xPadding,
    yPadding = _a.yPadding;
  var _b = getPaddingValues({
      padding: xPadding || 0,
      theme: theme
    }),
    xPadS = _b[0],
    xPadM = _b[1],
    xPadL = _b[2],
    xPadXl = _b[3];
  var _c = getPaddingValues({
      padding: yPadding || 0,
      theme: theme
    }),
    yPadS = _c[0],
    yPadM = _c[1],
    yPadL = _c[2],
    yPadXl = _c[3];
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    padding: ", " ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    padding: ", " ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), maxWidth || '1400px', yPadS, xPadS, media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), yPadM, xPadM), media.greaterThan('m')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), yPadL, xPadL), media.greaterThan('l')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), yPadXl, xPadXl));
};
/**
 * Section component
 * @param {SectionProps} { children, name, className, reference }
 * @returns {React.ReactNode} Section element
 */
var SectionComponent = function (_a) {
  var children = _a.children,
    name = _a.name,
    className = _a.className,
    reference = _a.reference,
    forwardedRef = _a.forwardedRef;
  return jsx("section", {
    className: className,
    id: name ? createSlug(name) : reference,
    ref: forwardedRef,
    children: children
  });
};
var Section = forwardRef(function (props, ref) {
  return jsx(SectionComponent, __assign({}, props, {
    forwardedRef: ref
  }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Section, getSectionSpacing };
//# sourceMappingURL=Section.js.map
